import React from 'react';
import { useTranslation } from 'react-i18next';
import './Services.css';
import AnimatedBackground from './AnimatedBackground';

const Services = () => {
  const { t } = useTranslation();
  const navigateToPage = (path) => {
    window.history.pushState({}, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  const services = [
    {
      titleKey: 'services.store.title',
      icon: 'shopping-cart',
      descriptionKey: 'services.store.description',
      buttonKey: 'services.store.button',
      action: () => navigateToPage('/tienda'),
      accent: 'warm'
    },
    {
      titleKey: 'services.wellness.title',
      icon: 'spa',
      descriptionKey: 'services.wellness.description',
      buttonKey: 'services.wellness.button',
      action: () => navigateToPage('/bienestar'),
      accent: 'nature'
    },
    {
      titleKey: 'services.conoceColombia.title',
      icon: 'map-marked-alt',
      descriptionKey: 'services.conoceColombia.description',
      buttonKey: 'services.conoceColombia.button',
      action: () => navigateToPage('/conoce-colombia'),
      accent: 'earth'
    },
    {
      titleKey: 'services.volunteering.title',
      icon: 'hands-helping',
      descriptionKey: 'services.volunteering.description',
      buttonKey: 'services.volunteering.button',
      action: () => navigateToPage('/voluntariado'),
      accent: 'warm'
    }
  ];

  return (
    <section className="services services-hero-inverted" id="servicios">
      <AnimatedBackground particleCount={6} staticCount={2} />
      <div className="services-inverted-layout">
        {/* Izquierda: texto (como Hero pero invertido - fondo hueso, texto negro) */}
        <div className="services-content-side">
          <span className="services-tag">{t('services.tag')}</span>
          <h2 className="services-headline">{t('services.headline')}</h2>
          <p className="services-subtitle">
            {t('services.subtitle')}
          </p>
          <button
            className="services-cta"
            onClick={() => navigateToPage('/servicios')}
          >
            {t('services.viewServices')}
          </button>
        </div>

        {/* Derecha: 4 servicios - diseño orgánico y empático */}
        <div className="services-grid-side">
          {services.map((s, i) => (
            <div
              key={i}
              className={`service-card-ecosystem service-card-accent-${s.accent}`}
              onClick={s.action}
            >
              <div className="service-card-ecosystem-inner">
                <div className="service-icon-ecosystem">
                  <i className={`fas fa-${s.icon}`}></i>
                </div>
                <h3 className="service-title-ecosystem">{t(s.titleKey)}</h3>
                <p className="service-desc-ecosystem">{t(s.descriptionKey)}</p>
                <button
                  className="service-btn-ecosystem"
                  onClick={(e) => { e.stopPropagation(); s.action(); }}
                >
                  {t(s.buttonKey)}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
